<template>
	<div>
		<v-snackbar :color="snackbar.color" v-model="snackbar.status" :timeout="snackbar.timeout" dark>
			<span class="text-caption font-weight-bold text-uppercase">{{snackbar.text}}</span>
			<template v-slot:action="{ attrs }">
				<v-btn class="font-weight-bold" text v-bind="attrs" @click="snackbar.status = false">Fechar</v-btn>
			</template>
		</v-snackbar>
		<v-col cols="12" class="pa-0">
			<v-card>
				<v-card-text>
					<v-form>
						<v-row class="mb-n10">
							<v-col cols="12" class="pb-0 d-flex">
								<v-col class="pa-0">
									<InputDatePicker
										:disabled="carregando"
										v-model="busca.dtinicio"
										label="Data inicial"
										:outlined="true"
										:dense="true"
									/>
								</v-col>
								<v-col class="pa-0 pl-3">
									<InputDatePicker
										:disabled="carregando"
										v-model="busca.dtfim"
										label="Data final"
										:outlined="true"
										:dense="true"
									/>
								</v-col>
								<v-col class="pa-0 pl-3">
									<v-select
										hide-details
										clearable
										:items="status.lista"
										item-text="status"
										item-value="idstatus"
										label="Status"
										outlined
										dense
										v-model="busca.idstatus"
									></v-select>
								</v-col>
<!--                <v-col class="pa-0 pl-3">-->
<!--                  <v-autocomplete-->
<!--                      clearable-->
<!--                      :items="devs.lista"-->
<!--                      item-text="usuario"-->
<!--                      item-value="idusuario"-->
<!--                      label="Desenvolvedor"-->
<!--                      outlined-->
<!--                      dense-->
<!--                      v-model="busca.idusuario"-->
<!--                      @change="listarUsuariosDevs()"-->
<!--                  ></v-autocomplete>-->
<!--                </v-col>-->
								<v-btn
									:disabled="carregando"
									class="ml-2 mt-1"
									color="primary"
									elevation="0"
									fab
									x-small
									@click="getTarefas(0)"
								>
									<v-icon>mdi-magnify</v-icon>
								</v-btn>
							</v-col>
							<v-col cols="12" class="pr-4 d-flex">
								<v-spacer />
                <span class="pr-3">
                  <v-switch
                      v-model="busca.visualLista"
                      :loading="carregando"
                      label="Kanban"
                      color="primary"
                      class="my-0 py-0"
                      @click="getTarefas(0)"
                  ></v-switch>
                </span>
								<span>
									<v-switch
										v-model="busca.filtroDemandasUsuario"
										:loading="carregando"
										label="Minhas demandas"
										color="primary"
										class="my-0 py-0"
										@click="getTarefas(0)"
									></v-switch>
								</span>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-col>
		<v-col cols="12" class="px-0" order="1" order-lg="1">
			<v-card>
				<v-card-title>
					Demandas
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						elevation="0"
						dark
						@click="dialogAdicionar = true, tarefaTemp = {}"
            :loading="carregando"
					>
            {{ $vuetify.breakpoint.smAndDown ? '' : 'Adicionar' }}
            <v-icon class="ma-0 ml-md-2">mdi-plus</v-icon>
          </v-btn>
          <v-btn
              class="ml-2"
              color="red darken-3"
              elevation="0"
              dark
              @click="gerarRelatorio()"
              :loading="carregando"
          > {{ $vuetify.breakpoint.smAndDown ? '' : 'Gerar Relatório' }}
            <v-icon size="28" class="ml-md-2">mdi-file-pdf-box</v-icon>
          </v-btn>
				</v-card-title>
				<v-divider />
				<v-card-text v-if="!busca.visualLista" class="px-0 pt-0">
					<v-data-table
						no-gutters
						hide-default-footer
						dense
            class="custom-table elevation-0"
						:headers="[
                { text: 'N°', value: 'idtarefa', sortable: false, align: 'start', class:'pr-2' },
                { text: 'Título', value: 'tarefa', sortable: false, class:'px-2'  },
                { text: 'Descrição', value: 'descricao', sortable: false, class:'px-2'  },
                { text: 'Solicitante', value: 'solicitante', align:' text-center', sortable: false, class:'px-2'  },
                { text: 'Setor', value: 'setor', align:' text-center', sortable: false, class:'px-2'  },
                { text: 'Status', value: 'status', sortable: false, align: 'center', class:'px-1'  },
                { text: 'Ações', value: 'actions', sortable: false, align: 'center', class:'pl-2' },
            ]"
						:items="dadosTarefa"
						:items-per-page="-1"
						mobile-breakpoint="0"
						sort-by="idtarefa"
						:sort-desc="true"
            item-class="styled-row"
            he
					>
						<template v-slot:item="{ item, index  }">
							<tr :class="rowClass(index, item)">
								<td width="1%">{{ item.idtarefa }}</td>
								<td class="px-2 text-uppercase" width="14%">{{ item.tarefa }}</td>
								<td
									width="55%"
									class="px-2 text-justify text-uppercase"
									v-html="item.descricao.replaceAll('***', '<br>')"
								></td>
								<td class="text-center px-2 text-uppercase" width="9%">{{ item.usuariosolicitacao }}</td>
								<td class="text-center px-2" width="6%">{{ item.setor }}</td>
								<td width="10%">
									<v-select
										style="font-size: 14px; padding: 0px"
										item-color="primary"
										:background-color="corItem(item.idstatus)"
										rounded
										dense
										dark
										hide-details
										:items="status.lista"
										item-text="status"
										item-value="idstatus"
										v-model="item.idstatus"
										@change="atualizarTarefa(item)"
									></v-select>
								</td>
								<td class="pl-2 text-center" width="5%" nowrap>
									<v-btn @click="exibirDetalhes(item,'D')" x-small dark class="primary pa-0">
										<v-icon small>mdi-note-plus</v-icon>
									</v-btn>
                  <v-btn @click="exibirDetalhes(item,'A')" x-small dark class="primary ml-1">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
									<v-btn @click="confirmaDelecao(item)" x-small dark class="ml-1 red darken-3">
										<v-icon small>mdi-delete</v-icon>
									</v-btn>
								</td>
							</tr>
						</template>
						<template v-slot:no-data>
							<span>Nenhum registro encontrado.</span>
						</template>
					</v-data-table>
				</v-card-text>
        <v-card-text v-else>
          <v-row>
            <v-col cols="12" md="3">
              <v-card class="quadro-demanda">
                <v-card-title class="primary white--text">
                  A Executar
                  <v-spacer />
                  <v-icon color="white">mdi-account-clock-outline</v-icon>
                </v-card-title>
                <v-card-text class="pa-0 quadro-demanda-text" v-if="lista1">
                  <draggable class="list-group" v-model="lista1" v-bind="dragOptions1" :move="onMove" @end="onEnd">
                    <transition-group id="s1" tag="ul" style="min-height: 40px !important;" class="pa-0">
                      <li
                          class="list-card-itens my-3 rounded white--text yellow darken-4"
                          v-for="l,i in lista1"
                          :key="i"
                      >
                        <div class="hover-div">
                          <span class="pa-3 pt-2 d-block" @click="exibirDetalhes(l,'D')">
                            <strong>{{ !l.usuariodesenvolvedor ? 'DENIFIR' : l.usuariodesenvolvedor }}: </strong>
                            <span class="hidden-prioridade white font-weight-bold yellow darken-4 white--text"> <h5>{{ l.idprioridade == 0 ? '' : l.prioridade }}</h5> </span>
                            <v-btn @click.stop="exibirDetalhes(l,'A')" icon x-small class="mt-n1 hidden-button font-weight-bold white"> <v-icon size="12">mdi-pencil</v-icon> </v-btn> <br/>
                            {{l.idtarefa}} - {{l.tarefa}}
                          </span>
                        </div>
                      </li>
                    </transition-group>
                  </draggable>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card class="quadro-demanda">
                <v-card-title class="primary white--text">
                  Executando
                  <v-spacer />
                  <v-icon color="white">mdi-timer-play-outline</v-icon>
                </v-card-title>
                <v-card-text class="pa-0 quadro-demanda-text" v-if="lista2">
                  <draggable class="list-group" v-model="lista2" v-bind="dragOptions3" :move="onMove" @end="onEnd">
                    <transition-group id="s2" tag="ul" style="min-height: 40px !important;">
                      <li
                          class="list-card-itens my-3 rounded white--text amber darken-4"
                          v-for="l,i in lista2"
                          :key="i"
                      >
                        <div class="hover-div">
                          <span class="pa-3 pt-2 d-block" @click="exibirDetalhes(l,'D')">
                            <strong>{{ l.usuariodesenvolvedor }}: </strong>
                            <span class="hidden-prioridade white font-weight-bold amber darken-4 white--text"> <h5>{{ l.idprioridade == 0 ? '' : l.prioridade }}</h5> </span>
                            <v-btn @click.stop="exibirDetalhes(l,'A')" icon x-small class="mt-n1 hidden-button font-weight-bold white"> <v-icon size="12">mdi-pencil</v-icon> </v-btn> <br/>
                            {{l.idtarefa}} - {{l.tarefa}}
                          </span>
                        </div>
                      </li>
                    </transition-group>
                  </draggable>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card class="quadro-demanda">
                <v-card-title class="primary white--text">
                  Pausada/Aguardando
                  <v-spacer />
                  <v-icon color="white">mdi-timer-pause-outline</v-icon>
                </v-card-title>
                <v-card-text class="pa-0 quadro-demanda-text" v-if="lista3">
                  <draggable class="list-group" v-model="lista3" v-bind="dragOptions2" :move="onMove" @end="onEnd">
                    <transition-group id="s3" tag="ul" style="min-height: 40px !important;">
                      <li
                          class="list-card-itens my-3 rounded white--text orange darken-4"
                          v-for="l,i in lista3"
                          :key="i"
                      >
                        <div class="hover-div">
                          <span class="pa-3 pt-2 d-block" @click="exibirDetalhes(l,'D')">
                            <strong>{{ l.usuariodesenvolvedor }}: </strong>
                            <span class="hidden-prioridade white font-weight-bold orange darken-4 white--text"> <h5>{{ l.idprioridade == 0 ? '' : l.prioridade }}</h5> </span>
                            <v-btn @click.stop="exibirDetalhes(l,'A')" icon x-small class="mt-n1 hidden-button font-weight-bold white"> <v-icon size="12">mdi-pencil</v-icon> </v-btn> <br/>
                            {{l.idtarefa}} - {{l.tarefa}}
                          </span>
                        </div>
                      </li>
                    </transition-group>
                  </draggable>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card class="quadro-demanda">
                <v-card-title class="primary white--text">
                  Concluídas
                  <v-spacer />
                  <v-icon color="white">mdi-clock-check-outline</v-icon>
                </v-card-title>
                <v-card-text class="pa-0 pb-2 quadro-demanda-text" v-if="lista4">
                  <draggable class="list-group" v-model="lista4" v-bind="dragOptions4" :move="onMove" @end="onEnd">
                    <transition-group id="s4" tag="ul" style="min-height: 40px !important;">
                      <li
                          class="list-card-itens my-3 rounded white--text primary"
                          v-for="l,i in lista4"
                          :key="i"
                      >
                        <div class="hover-div">
                          <span class="pa-3 pt-2 d-block" @click="exibirDetalhes(l,'D')">
                            <strong>{{ l.usuariodesenvolvedor }}: </strong>
                            <span class="hidden-prioridade white font-weight-bold primary white--text"> <h5>{{ l.idprioridade == 0 ? '' : l.prioridade }}</h5> </span>
                            <v-btn @click.stop="exibirDetalhes(l,'A')" icon x-small class="mt-n1 hidden-button font-weight-bold white"> <v-icon size="12">mdi-pencil</v-icon> </v-btn> <br/>
                            {{l.idtarefa}} - {{l.tarefa}}
                          </span>
                        </div>
                      </li>
                    </transition-group>
                  </draggable>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
			</v-card>
		</v-col>
    <v-dialog v-model="dialogAlterar" max-width="1000px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #FFF;" class="text-h5">Alterar demanda</span>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="text-body-1 font-weight-bold">Título</div>
              <v-text-field hide-details outlined dense v-model="dadosAlteracao.tarefa"></v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <div class="text-body-1 font-weight-bold">Descrição</div>
              <v-textarea hide-details outlined dense v-model="dadosAlteracao.descricao"></v-textarea>
            </v-col>
            <v-col cols="12" md="3" class="pb-0">
              <div class="text-body-1 font-weight-bold">Solicitante</div>
              <v-autocomplete
                  hide-details
                  v-model="dadosAlteracao.idusuariosolicitacao"
                  outlined
                  dense
                  :items="usuarios.lista"
                  :loading="carregando"
                  item-text="usuario"
                  item-value="idusuario"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="pb-0">
              <div class="text-body-1 font-weight-bold">Setor</div>
              <v-autocomplete
                  hide-details
                  v-model="dadosAlteracao.idsetor"
                  outlined
                  dense
                  :items="setor"
                  :loading="carregando"
                  item-text="setor"
                  item-value="idsetor"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="pb-0">
              <div class="text-body-1 font-weight-bold">Prioridade</div>
              <v-autocomplete
                  hide-details
                  v-model="dadosAlteracao.idprioridade"
                  outlined
                  dense
                  :items="prioridade"
                  :loading="carregando"
                  item-text="prioridade"
                  item-value="idprioridade"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="pb-0">
              <div class="text-body-1 font-weight-bold">Faz parte do planejamento?</div>
              <v-autocomplete
                  hide-details
                  v-model="dadosAlteracao.idplanejamento"
                  outlined
                  dense
                  :items="planejamento"
                  :loading="carregando"
                  item-text="planejamento"
                  item-value="idplanejamento"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogAlterar = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="alterarTarefas()" :disabled="dadosAlteracao.descricao.length <=0 || dadosAlteracao.tarefa.length <=0 || !dadosAlteracao.idusuariosolicitacao || !dadosAlteracao.idsetor">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAdicionar" max-width="1000px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #FFF;" class="text-h5">Nova demanda</span>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="text-body-1 font-weight-bold">Título</div>
              <v-text-field hide-details outlined dense v-model="tarefaTemp.tarefa"></v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <div class="text-body-1 font-weight-bold">Descrição</div>
              <v-textarea hide-details outlined dense v-model="tarefaTemp.descricao"></v-textarea>
            </v-col>
            <v-col cols="12" md="3" class="pb-0">
              <div class="text-body-1 font-weight-bold">Solicitante</div>
              <v-autocomplete
                  hide-details
                  v-model="tarefaTemp.idusuariosolicitacao"
                  outlined
                  dense
                  :items="usuarios.lista"
                  :loading="carregando"
                  item-text="usuario"
                  item-value="idusuario"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="pb-0">
              <div class="text-body-1 font-weight-bold">Setor</div>
              <v-autocomplete
                  hide-details
                  v-model="tarefaTemp.idsetor"
                  outlined
                  dense
                  :items="setor"
                  :loading="carregando"
                  item-text="setor"
                  item-value="idsetor"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="pb-0">
              <div class="text-body-1 font-weight-bold">Prioridade</div>
              <v-autocomplete
                  hide-details
                  v-model="tarefaTemp.idprioridade"
                  outlined
                  dense
                  :items="prioridade"
                  :loading="carregando"
                  item-text="prioridade"
                  item-value="idprioridade"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="pb-0">
              <div class="text-body-1 font-weight-bold">Faz parte do Planejamento?</div>
              <v-autocomplete
                  hide-details
                  v-model="tarefaTemp.idplanejamento"
                  outlined
                  dense
                  :items="planejamento"
                  :loading="carregando"
                  item-text="planejamento"
                  item-value="idplanejamento"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogAdicionar = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="adicionarTarefas()" :disabled="!tarefaTemp.descricao || !tarefaTemp.tarefa || !tarefaTemp.idusuariosolicitacao || !tarefaTemp.idprioridade || !tarefaTemp.idsetor">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetalhe" width="100%" max-width="730px" scrollable>
      <!-- DIALOG DETALHES E REGISTROS TAREFAS -->
      <v-card>
        <v-card-title class="primary px-4 py-3">
          <span style="color: #FFF;">{{tarefaTemp.tarefa}}</span>
          <v-spacer />
          <small style="color: #FFF;" class="pr-4" v-text="`Nº ${tarefaTemp.idtarefa}`"></small>
          <v-icon dark @click="dialogDetalhe = false, tarefaTemp = {}">mdi-window-close</v-icon>
        </v-card-title>
        <v-card-subtitle class="pa-0 pt-4">
          <v-tabs v-model="tab" grow show-arrows>
            <v-tab href="#tab-1" class="px-3 px-sm-3 px-md-0" active-class="indigo lighten-5">
              <span>Registros</span>
            </v-tab>
            <v-tab href="#tab-2" class="px-3 px-sm-3 px-md-0" active-class="indigo lighten-5">
              <span>Arquivos</span>
            </v-tab>
            <v-tab href="#tab-3" class="px-3 px-sm-3 px-md-0" active-class="indigo lighten-5">
              <span>Detalhes</span>
            </v-tab>
          </v-tabs>
          <v-divider />
        </v-card-subtitle>
        <v-card-text class="py-0 pt-1 px-0">
          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
              <v-row no-gutters>
                <v-col cols="12" class="pt-0" style="min-height: 150px">
                  <v-card elevation="0">
                    <v-card-text class="text-tuncrate container-scroll">
                      <v-skeleton-loader
                          v-if="carregando"
                          class="px-2"
                          width="100%"
                          type="heading, list-item-two-line"
                      ></v-skeleton-loader>
                      <template v-else>
                        <v-list two-line class="mt-n3">
                          <v-list-item v-for="(u, i) in registros.lista" :key="i" class="mb-n6">
                            <v-list-item-content>
                              <v-list-item-title>
                                <span class="font-weight-bold">{{u.usuarioregistro}}:</span>
                                <small class="float-right">{{u.dataregistro}}</small>
                              </v-list-item-title>
                              <p class="pl-3">
                                <v-icon size="14">mdi-check-all</v-icon>
                                {{u.registro}}
                              </p>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-divider />
            </v-tab-item>
            <v-tab-item value="tab-2">
              <v-row no-gutters>
                <v-col cols="12" class="pt-0" style="min-height: 150px">
                  <v-card elevation="0">
                    <v-card-text class="px-5">
                      <v-chip
                          @click="arquivoDownload(a.idarquivo)"
                          class="ma-2"
                          v-for="(a,i) in tarefaTemp.arquivo"
                          :key="i"
                      >
                        <v-icon left small>mdi-cloud-download</v-icon>
                        {{a.arquivoname}}
                      </v-chip>
                      <span v-if="!tarefaTemp.arquivo">Nenhum arquivo anexado.</span>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-divider />
            </v-tab-item>
            <v-tab-item value="tab-3">
              <v-row no-gutters>
                <v-col cols="12" class="pt-6" style="min-height: 150px">
                  <v-list-item two-line class="mt-n5">
                    <v-list-item-title class="text-body-1 text-truncate">
                      <v-icon class="mr-1 mb-1">mdi-timer</v-icon>Previsão de entrega
                      <v-chip
                          class="float-right pa-3"
                          small
                      >{{tarefaTemp.tempomedio != null ? tarefaTemp.tempomedio : 'Não definido'}}</v-chip>
                    </v-list-item-title>
                  </v-list-item>
                  <!-- PREVISÃO  -->
                  <v-list-item two-line class="mt-n4">
                    <v-list-item-title>
                      <v-icon class="mr-1 mb-1">mdi-account</v-icon>Solicidado por
                      <br />
                      <!--                        <span class="text-truncate" style="font-size: 12px">{{tarefaTemp.dhcadastro}}</span>-->
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-body-1 text-truncate">
                      <v-chip class="float-right pa-3" small>{{tarefaTemp.usuariosolicitacao}}</v-chip>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <!-- SOLICITADO POR -->
                  <v-list-item class="mt-n4" two-line v-if="tarefaTemp.dhconcluido">
                    <v-list-item-title class="text-body-1 text-truncate">
                      <v-icon class="mr-1 mb-1">mdi-account-check</v-icon>Concluída por
                      <br />
                      <!--                        <span class="text-truncate" style="font-size: 12px">{{tarefaTemp.dhconcluido}}</span>-->
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-body-1 text-truncate">
                      <v-chip class="float-right pa-3" small>{{tarefaTemp.usuarioconclusao}}</v-chip>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <!-- CONCLUÍDA POR  -->
                  <v-list-item two-line class="mt-n4">
                    <v-list-item-title class="text-body-1 text-truncate">
                      <v-icon class="mr-1 mb-1">mdi-calendar-clock</v-icon>Data de cadastro
                      <v-chip class="float-right pa-3" small>{{tarefaTemp.dhcadastro}}</v-chip>
                    </v-list-item-title>
                  </v-list-item>
                  <!-- DATA CADASTRO  -->
                  <v-list-item two-line v-if="tarefaTemp.dhconcluido" class="mt-n4">
                    <v-list-item-title class="text-body-1 text-truncate">
                      <v-icon class="mr-1 mb-1">mdi-calendar-check</v-icon>Data de conclusão
                      <v-chip class="float-right pa-3" small>{{tarefaTemp.dhconcluido}}</v-chip>
                    </v-list-item-title>
                  </v-list-item>
                  <!-- DATA CONCLUIDO  -->
                  <v-list-item two-line v-if="tarefaTemp.dhvalidacao" class="mt-n4">
                    <v-list-item-title class="text-body-1 text-truncate">
                      <v-icon class="mr-1 mb-1">mdi-calendar-account</v-icon>Data de validação
                      <v-chip class="float-right pa-3" small>{{tarefaTemp.dhvalidacao}}</v-chip>
                    </v-list-item-title>
                  </v-list-item>
                  <!-- DATA VALIDACAO  -->
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-card-text class="pa-0">
            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-1">
                <v-row no-gutters>
                  <v-col cols="8" class="pa-0">
                    <v-textarea v-model="registro" hide-details dense outlined rows="1" style="resize: none !important;">></v-textarea>
                  </v-col>
                  <v-col cols="4" class="pa-0 pl-3">
                    <v-btn
                        height="38px"
                        width="100%"
                        @click="adicionarRegistro()"
                        elevation="0"
                        color="primary"
                    >
                      <v-icon class="pr-1">mdi-plus</v-icon>Registrar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="tab-2">
                <v-row no-gutters>
                  <v-col cols="8" class="pa-0">
                    <v-file-input
                        hide-details
                        small
                        multiple
                        outlined
                        dense
                        prepend-icon
                        prepend-inner-icon="mdi-paperclip"
                        @change="adicionarArquivo"
                        :key="resetKey"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="4" class="pa-0 pl-3">
                    <v-btn @click="arquivoNovo(tarefaTemp)" elevation="0" color="primary" width="100%" height="38px" :disabled="carregando">
                      <v-icon>mdi-upload</v-icon>Enviar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="tab-3"></v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h6">Tem que certeza que deseja excluir essa tarefa?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogDelete = false, tarefaTemp = {}">Cancelar</v-btn>
          <v-btn color="primary" text @click="deletarTarefa(tarefaTemp), dialogDelete = false">SIM</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="carregandoPdf" persistent overlay-opacity="0.99" width="350px">
      <v-card color="primary" dark class="text-center pa-5 rounded-lg" elevation="0" :style="estilosCard">
        <v-card-text>
          <v-icon size="80" class="my-3 icon-slide" v-if="progresso<100">mdi-file-download</v-icon>
          <v-icon size="80" class="my-3" v-else>mdi-file-check</v-icon>

          <div class="text-h6 font-weight-bold mb-2">
            Gerando Relatório...
          </div>
          <p class="text-body-2 mb-4">
            Por favor, aguarde. Isso pode levar alguns segundos.
          </p>

          <v-progress-linear
              :value="progresso"
              color="white"
              height="8"
              rounded
              striped
          ></v-progress-linear>

          <div class="mt-2 text-caption">
            {{ progresso }}% concluído
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div v-show="carregandoPdf">
      <div id="charts-container" style="width: 210mm !important;">
        <div class="demand-header2" style="margin-top: 20px;">
          <h2>Setores Solicitantes</h2>
        </div>
        <div ref="chartsContainer" class="time-container3">
          <GraficoBarDashboardTarefas
              v-if="totalRelatorio.totalsetor.length>0"
              :key="JSON.stringify(totalRelatorio.totalsetor)"
              :dataSeries="[{
                name: 'Tickets',
                data: totalRelatorio.totalsetor.map(v => {return v.quantidade})
              }]"
              :categories="totalRelatorio.totalsetor.map(v => {return v.setor})"
              :horizontal="false"
              :money="false"
              :porcentagem="false"
              height="300"
              :distributed="true"
              :dataLabels="{ position : 'bottom', orientation : 'horizontal', offsetY: 20 }"
          />
        </div>
        <div class="demand-header2">
          <h2>Usuários Solicitantes</h2>
        </div>
        <div ref="chartsContainer" class="time-container3">
          <GraficoBarDashboardTarefas
              v-if="totalRelatorio.totalusuario.length>0"
              :key="JSON.stringify(totalRelatorio.totalusuario)"
              :dataSeries="[{
                name: 'Tickets',
                data: totalRelatorio.totalusuario.map(v => {return v.quantidade})
              }]"
              :categories="totalRelatorio.totalusuario.map(v => {return v.usuario})"
              :horizontal="false"
              :money="false"
              :porcentagem="false"
              height="300"
              :distributed="true"
              :dataLabels="{ position : 'bottom', orientation : 'horizontal', offsetY: 20 }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import InputDatePicker from "@/Components/Widgets/InputDatePicker";
import html2pdf from "html2pdf.js";
import draggable from "vuedraggable";
import GraficoBarDashboardTarefas from "@/Components/Widgets/GraficoBarDashboardTarefas.vue";
import jsPDF from "jspdf";
import domtoimage from 'dom-to-image';


export default {
	components: {GraficoBarDashboardTarefas, InputDatePicker, draggable },
	data: () => ({
    progresso: 0,
    totalPaginas: 0,

    dialog: false,
    editable: true,
    devs:[],
    resetKey: 0,
		statusTarefa: 0,
		status: { lista: [] },
		pgLimitInt: 20,
		pgSelecionada: 0,
		carregando: false,
		tab: null,
		arquivos: [],
		snackbar: { status: false, timeout: 2000 },
		busca: {
			dtinicio: `${new Date().getFullYear()}-${
				(new Date(
					new Date().getFullYear(),
					new Date().getMonth() + 1,
					0
				).getMonth() +
					1 <
				10
					? "0"
					: "") +
				(new Date().getMonth() + 1)
			}-01`,
      dtfim: `${new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
      ).getFullYear()}-${
          (new Date(
              new Date().getFullYear(),
              new Date().getMonth() + 1,
              0
          ).getMonth() +
          1 <
          10
              ? "0"
              : "") +
          (new Date().getMonth() + 1)
      }-${new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
      ).getDate()}`,
      visualLista: false,
      filtroDemandasUsuario: false,
      idstatus: null,
		},
		dialogAdicionar: false,
		dialogAlterar: false,
		dialogDetalhe: false,
		dialogDelete: false,
		totalTarefa: {},
		dadosTarefa: [],
    estruturaHtml: '',
    estruturaHtml2: '',
		tarefaTemp: {
			idtarefa: 0,
		},
    dadosAlteracao: {
      descricao: '',
      tarefa: '',
    },
    tarefaAtualiza: {},
    idStatusAtualiza: {},
		usuarios: { lista: [] },
		registros: {},
		registro: "",
    dadosRelatorio: [],
    totalRelatorio: { totalsetor: [], totalusuario: [] },
    carregandoPdf:false,
    lista1: [],
    lista2: [],
    lista3: [],
    lista4: [],
    prioridade: [],
    setor:[],
    planejamento: [],
	}),

	computed: {
		...mapState(["backendUrl", "usuario"]),
    dragOptions1() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
    dragOptions2() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
    dragOptions3() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
    dragOptions4() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
    estilosCard() {
      return this.$vuetify.breakpoint.smAndDown
          ? { position: "fixed", left: "10px", top: "300px", width:`${this.$vuetify.breakpoint.width-20}px` }
          : {};
    }
	},
	methods: {
    onEnd() {
        setTimeout(() => {
          if (this.idStatusAtualiza != 0) {
            this.atualizarTarefa(this.tarefaAtualiza, this.idStatusAtualiza)
          }
        }, 10);
    },
    onMove(e) {
      const { from, to } = e;
      switch (true) {
        case from.id === "s1" && to.id === "s2":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 2;
          return true;

        case from.id === "s1" && to.id === "s3":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 3;
          return true;

        case from.id === "s1" && to.id === "s4":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 4;
          return true;

        case from.id === "s2" && to.id === "s3":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 3;
          return true;

        case from.id === "s2" && to.id === "s4":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 4;
          return true;

        case from.id === "s3" && to.id === "s2":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 2;
          return true;

        case from.id === "s3" && to.id === "s4":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 4;
          return true;

        case from.id === "s4" && to.id === "s2":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 2;
          return true;

        case from.id === "s4" && to.id === "s3":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 3;
          return true;

        case from.id === "s4" && to.id === "s1":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 1;
          return true;

        case from.id === "s3" && to.id === "s1":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 1;
          return true;

        case from.id === "s2" && to.id === "s1":
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 1;
          return true;

        default:
          this.tarefaAtualiza = e.draggedContext.element;
          this.idStatusAtualiza = 0;
          return true;
      }
    },
    async gerarRelatorio() {
      this.progresso=0;
      this.carregandoPdf = true;
      await this.buscarDados();
      await this.gerarPdf();
      setTimeout(() => {
        this.carregandoPdf = false;
        this.carregando = false;
      }, 3000);
    },
    async buscarDados(){
      return axios
          .post(`${this.backendUrl}projeto/tarefa/listar`, {
            limit: 1000,
            offset: 0,
            idprojeto: 1,
            dtini: this.busca.dtinicio || null,
            dtfim: this.busca.dtfim || null,
            idstatus: this.busca.idstatus,
            filtroDemandasUsuario: this.busca.filtroDemandasUsuario,
          })
          .then(async (res) => {
            if (res.data.lista != null) {
              this.carregando = false;
              this.totalRelatorio = res.data.totais;
              this.dadosRelatorio = res.data.lista;
            } else {
              this.carregandoPdf = false;
            }
          })
          .catch(() => {
            this.carregando = false;
            this.carregandoPdf = false;
          });
    },

    async gerarPdf(){
      var dtini = this.formataData(
          this.busca.dtinicio
      );
      var dtfim = this.formataData(
          this.busca.dtfim
      );

      const dt1 = new Date(this.busca.dtinicio);
      const dt2 = new Date(this.busca.dtfim);

      // Diferença em milissegundos
      const diffTime = Math.abs(dt2 - dt1);

      // Converter de milissegundos para dias
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      const totalPaginas = Math.ceil(this.dadosRelatorio.length / 4) + 2; // Calcula o total incluindo capa e gráficos
      this.totalPaginas = totalPaginas;
      this.progresso = 0;

      let agora = new Date();

      let ano = agora.getFullYear();
      let mes = ('0' + (agora.getMonth() + 1)).slice(-2); // +1 porque o mês começa do zero
      let dia = ('0' + agora.getDate()).slice(-2);
      let hora = ('0' + agora.getHours()).slice(-2);
      let minuto = ('0' + agora.getMinutes()).slice(-2);

      let nomeArquivo = `Demandas_TI_${ano}${mes}${dia}_${hora}${minuto}.pdf`;

      const opt = {
        margin:       [0, 0],
        filename:     nomeArquivo,
        image:        { type: 'jpeg', quality: 1 },
        html2canvas:  { dpi: 192, scale: 2 },
        jsPDF:        { unit: 'pt', format: 'a4', orientation: 'portrait' }
      };

      const doc = new jsPDF(opt.jsPDF);
      const pageSize = jsPDF.getPageSize(opt.jsPDF);

      let htmlCapa = `
              <!DOCTYPE html>
              <html lang="pt-br">
              <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <title>Relatório de Demandas Executadas</title>
                  <style>
                      body, html {
                          margin: 0;
                          padding: 0;
                          width: 100%;
                          height: 100%;
                          font-family: Arial, sans-serif;
                          background-color: #f0f0f0;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                      }
                      .cover {
                          width: 210mm;
                          height: 297mm;
                          background-color: #023449;
                          display: flex;
                          flex-direction: column;
                          justify-content: center;
                          align-items: center;
                          text-align: center;
                          color: white;
                          padding: 20px;
                          box-sizing: border-box;
                          border: 1px solid #ccc; /* Opcional: adiciona uma borda para visualizar os limites da folha */
                      }
                      .cover h1 {
                          font-size: 2.5em;
                          margin-bottom: 0.5em;
                      }
                      .cover h2 {
                          font-size: 1.5em;
                          margin-bottom: 1em;
                      }
                      .cover p {
                          font-size: 0.9em;
                      }
                      .logo {
                          margin-bottom: 240px;
                      }
                      .logo img {
                          width: 200px;
                          height: auto;
                      }
                      .page-break {
                          page-break-before: always;
                          break-before: page;
                      }
                  </style>
              </head>
              <body>
                  <div class="cover">
                      <div class="logo">
                          <svg width="320" height="140" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                              <g filter="url(#filter0_d_1_16)">
                              <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                              </g>
                              <g filter="url(#filter1_d_1_16)">
                              <rect x="235" y="308" width="158" height="158" fill="white"/>
                              </g>
                              <g filter="url(#filter2_d_1_16)">
                              <rect x="7" y="245" width="221" height="221" fill="white"/>
                              </g>
                              <g filter="url(#filter3_d_1_16)">
                              <rect x="7" y="13" width="221" height="221" fill="white"/>
                              </g>
                              <defs>
                              <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feOffset dx="9" dy="4"/>
                              <feGaussianBlur stdDeviation="3.5"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feOffset dx="10" dy="-4"/>
                              <feGaussianBlur stdDeviation="4"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                              <feOffset dx="18" dy="12"/>
                              <feGaussianBlur stdDeviation="11"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                              <feOffset dx="18" dy="12"/>
                              <feGaussianBlur stdDeviation="11"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              </defs>
                          </svg>
                      </div>
                      <h1>Relatório de Demandas</h1>
                      <h2>Setor de Desenvolvimento TI</h2>
                      <p>Período: ${dtini} à ${dtfim}</p>
                  </div>
              </body>
              </html>

               `;
      const elemento = document.createElement('div');
      elemento.innerHTML = htmlCapa;
      document.body.appendChild(elemento);
      this.progresso = Math.round((1 / totalPaginas) * 100); // Atualiza a barra de progresso

      try {
        const dataUrl = await domtoimage.toJpeg(elemento, { quality: 1 });
        doc.addImage(dataUrl, 'JPEG', opt.margin[0], opt.margin[1], pageSize.width, pageSize.height);
        doc.addPage();
      } catch (error) {
        console.error('Erro ao converter HTML para imagem:', error);
      }

      // Remove o elemento temporário após a captura
      document.body.removeChild(elemento);

      for (let i = 0; i < this.dadosRelatorio.length; i += 4) {
        let htmlContent = '';
        if (i + 3 < this.dadosRelatorio.length) {
          htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;

                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                              width: 210mm !important;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                              width: 210mm !important;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                              width: 210mm !important;
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade} </p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 1].idtarefa} - ${this.dadosRelatorio[i + 1].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 1].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 1].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 1].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 1].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 1].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 1].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 1].dhinicioexecucao ? '' : this.dadosRelatorio[i + 1].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 1].dhconcluido ? '' : this.dadosRelatorio[i + 1].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 1].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 1].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 1].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 1].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                  <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 2].idtarefa} - ${this.dadosRelatorio[i + 2].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 2].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 2].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 2].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 2].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 2].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 2].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 2].dhinicioexecucao ? '' : this.dadosRelatorio[i + 2].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 2].dhconcluido ? '' : this.dadosRelatorio[i + 2].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 2].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 2].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 2].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 2].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                  <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 3].idtarefa} - ${this.dadosRelatorio[i + 3].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 3].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 3].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 3].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 3].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 3].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 3].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 3].dhinicioexecucao ? '' : this.dadosRelatorio[i + 3].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 3].dhconcluido ? '' : this.dadosRelatorio[i + 3].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 3].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 3].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 3].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 3].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 3].tempo ? '0s' : this.dadosRelatorio[i + 3].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 3].tempo ? '0s' : this.dadosRelatorio[i + 3].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
        } else if (i + 2 < this.dadosRelatorio.length) {
          htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                              width: 210mm !important;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                              width: 210mm !important;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                              width: 210mm !important;
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade}</p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 1].idtarefa} - ${this.dadosRelatorio[i + 1].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 1].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 1].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 1].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 1].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 1].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 1].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 1].dhinicioexecucao ? '' : this.dadosRelatorio[i + 1].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 1].dhconcluido ? '' : this.dadosRelatorio[i + 1].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 1].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 1].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 1].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 1].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                  <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 2].idtarefa} - ${this.dadosRelatorio[i + 2].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 2].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 2].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 2].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 2].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 2].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 2].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 2].dhinicioexecucao ? '' : this.dadosRelatorio[i + 2].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 2].dhconcluido ? '' : this.dadosRelatorio[i + 2].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 2].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 2].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 2].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 2].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
        } else if (i + 1 < this.dadosRelatorio.length) {
          htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                              width: 210mm !important;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                              width: 210mm !important;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                              width: 210mm !important;
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade}</p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 1].idtarefa} - ${this.dadosRelatorio[i + 1].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 1].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 1].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 1].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 1].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 1].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 1].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 1].dhinicioexecucao ? '' : this.dadosRelatorio[i + 1].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 1].dhconcluido ? '' : this.dadosRelatorio[i + 1].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 1].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 1].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 1].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 1].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
        } else {
          htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                              width: 210mm !important;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                              width: 210mm !important;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                              width: 210mm !important;
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade}</p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
        }

        const elemento = document.createElement('div');
        elemento.innerHTML = htmlContent;
        document.body.appendChild(elemento);

        try {
          const dataUrl = await domtoimage.toJpeg(elemento, { quality: 1 });
          doc.addImage(dataUrl, 'JPEG', opt.margin[0], opt.margin[1]);
          doc.addPage();
        } catch (error) {
          console.error('Erro ao converter HTML para imagem:', error);
        }
        document.body.removeChild(elemento);
        this.progresso = Math.round(((i / 4 + 2) / totalPaginas) * 100);
      }

      const chartsContainer = document.getElementById('charts-container');

      var body1 = chartsContainer.innerHTML;

      let htmlTotais = `
                <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header2 {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                              width: 210mm !important;
                          }

                          .header2 h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader2 {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                              width: 210mm !important;
                          }

                          .subheader2 h6 {
                              margin: 0;
                          }


                          .report-container2 {
                              background-color: #fff;
                              padding: 20px 20px 12px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              width: 210mm !important;
                          }
                          .demand-header2 {
                              border-bottom: 1px solid #333;
                              margin-bottom: 10px;
                              padding-bottom: 10px;
                          }
                          .demand-header2 h2 {
                              margin: 0;
                              font-size: 20px;
                              width: 199mm !important;
                          }

                          .demand-info2 {
                              margin: 20px 0 15px 0;
                          }
                          .demand-info2 p {
                              margin: 5px 0;
                          }

                          .demand-info2 p {
                              margin: 5px 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info2 p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container2 {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr);
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                              border: 1px solid #ddd;
                          }
                          .time-container2 p {
                              margin: 0;
                              font-size: 13px;
                          }
                          .grafico{
                              display: block !important;
                          }
                          /*.report-container-pai{*/
                          /*    display: grid;*/
                          /*    grid-template-columns: repeat(2, 1fr);*/
                          /*    gap: 10px;*/
                          /*    background-color: #f1f1f1;*/
                          /*    padding: 10px;*/
                          /*    border-radius: 5px;*/
                          /*    margin: 10px 0;*/
                          /*    border: 1px solid #ddd;*/
                          /*}*/
                      </style>
                  </head>
                  <body>
                  <div class="header2">
                      <h2>Relatório de Demandas TI - Sintético</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader2">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container2">
                      <div class="demand-header2">
                          <h2>Totais</h2>
                      </div>

                      <div class="demand-info2">
                          <div class="time-container2">
                              <p><strong>Total Demandas:</strong> ${!this.totalRelatorio.totaldemandas ? 0 : this.totalRelatorio.totaldemandas}</p>
                              <p><strong>Total Concluídas:</strong> ${!this.totalRelatorio.totalconcluidas ? 0 : this.totalRelatorio.totalconcluidas}</p>
                              <p><strong>Total Pendentes:</strong> ${!this.totalRelatorio.totalpendentes ? 0 : this.totalRelatorio.totalpendentes}</p>
                              <p><strong>Qtde de Dias Filtrados:</strong> ${diffDays} dias </p>
                          </div>
                      </div>
                  </div>
                  ${body1}
                  </body>
                  </html>
      `;
      const elemento2 = document.createElement('div');
      elemento2.innerHTML = htmlTotais;
      document.body.appendChild(elemento2);

      try {
        const dataUrl = await domtoimage.toPng(elemento2, { quality: 1 });
        doc.addImage(dataUrl, 'PNG', opt.margin[0], opt.margin[1]);
      } catch (error) {
        console.error('Erro ao converter HTML para imagem:', error);
      }

      // Remove o elemento temporário após a captura
      document.body.removeChild(elemento2);

      doc.save(opt.filename);
      this.progresso = 100;
    },


    async gerarPdfBkpHtml2Pdf(){
      var dtini = this.formataData(
          this.busca.dtinicio
      );
      var dtfim = this.formataData(
          this.busca.dtfim
      );

      const chartsContainer = document.getElementById('charts-container');
      const chartsContainer2 = document.getElementById('charts-container2');

      let agora = new Date();

      let ano = agora.getFullYear();
      let mes = ('0' + (agora.getMonth() + 1)).slice(-2); // +1 porque o mês começa do zero
      let dia = ('0' + agora.getDate()).slice(-2);
      let hora = ('0' + agora.getHours()).slice(-2);
      let minuto = ('0' + agora.getMinutes()).slice(-2);

      let nomeArquivo = `Demandas_TI_${ano}${mes}${dia}_${hora}${minuto}.pdf`;

      const opt = {
        margin:       [0, 0],
        filename:     nomeArquivo,
        image:        { type: 'jpeg', quality: 1 },
        html2canvas:  { dpi: 192, scale: 2 },
        jsPDF:        { unit: 'pt', format: 'a4', orientation: 'portrait' }
      };

      const doc = new jsPDF(opt.jsPDF);
      const pageSize = jsPDF.getPageSize(opt.jsPDF);

      // Criando um array de promessas para processar todas as imagens em paralelo
      let promessas = [];
      var htmlContent = '';
      let htmlCapa = `
              <!DOCTYPE html>
              <html lang="pt-br">
              <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <title>Relatório de Demandas Executadas</title>
                  <style>
                      body, html {
                          margin: 0;
                          padding: 0;
                          width: 100%;
                          height: 100%;
                          font-family: Arial, sans-serif;
                          background-color: #f0f0f0;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                      }
                      .cover {
                          width: 210mm;
                          height: 297mm;
                          background-color: #023449;
                          display: flex;
                          flex-direction: column;
                          justify-content: center;
                          align-items: center;
                          text-align: center;
                          color: white;
                          padding: 20px;
                          box-sizing: border-box;
                          border: 1px solid #ccc; /* Opcional: adiciona uma borda para visualizar os limites da folha */
                      }
                      .cover h1 {
                          font-size: 2.5em;
                          margin-bottom: 0.5em;
                      }
                      .cover h2 {
                          font-size: 1.5em;
                          margin-bottom: 1em;
                      }
                      .cover p {
                          font-size: 0.9em;
                      }
                      .logo {
                          margin-bottom: 240px;
                      }
                      .logo img {
                          width: 200px;
                          height: auto;
                      }
                      .page-break {
                          page-break-before: always;
                          break-before: page;
                      }
                  </style>
              </head>
              <body>
                  <div class="cover">
                      <div class="logo">
                          <svg width="320" height="140" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                              <g filter="url(#filter0_d_1_16)">
                              <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                              </g>
                              <g filter="url(#filter1_d_1_16)">
                              <rect x="235" y="308" width="158" height="158" fill="white"/>
                              </g>
                              <g filter="url(#filter2_d_1_16)">
                              <rect x="7" y="245" width="221" height="221" fill="white"/>
                              </g>
                              <g filter="url(#filter3_d_1_16)">
                              <rect x="7" y="13" width="221" height="221" fill="white"/>
                              </g>
                              <defs>
                              <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feOffset dx="9" dy="4"/>
                              <feGaussianBlur stdDeviation="3.5"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feOffset dx="10" dy="-4"/>
                              <feGaussianBlur stdDeviation="4"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                              <feOffset dx="18" dy="12"/>
                              <feGaussianBlur stdDeviation="11"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                              <feOffset dx="18" dy="12"/>
                              <feGaussianBlur stdDeviation="11"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              </defs>
                          </svg>
                      </div>
                      <h1>Relatório de Demandas</h1>
                      <h2>Setor de Desenvolvimento TI</h2>
                      <p>Período: ${dtini} à ${dtfim}</p>
                  </div>
              </body>
              </html>

               `;
      promessas.push(html2pdf().from(htmlCapa).set(opt).outputImg());

      for (let i = 0; i < this.dadosRelatorio.length; i += 4) {
        if (i + 3 < this.dadosRelatorio.length) {
          htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade} </p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 1].idtarefa} - ${this.dadosRelatorio[i + 1].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 1].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 1].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 1].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 1].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 1].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 1].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 1].dhinicioexecucao ? '' : this.dadosRelatorio[i + 1].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 1].dhconcluido ? '' : this.dadosRelatorio[i + 1].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 1].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 1].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 1].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 1].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                  <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 2].idtarefa} - ${this.dadosRelatorio[i + 2].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 2].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 2].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 2].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 2].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 2].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 2].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 2].dhinicioexecucao ? '' : this.dadosRelatorio[i + 2].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 2].dhconcluido ? '' : this.dadosRelatorio[i + 2].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 2].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 2].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 2].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 2].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                  <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 3].idtarefa} - ${this.dadosRelatorio[i + 3].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 3].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 3].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 3].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 3].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 3].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 3].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 3].dhinicioexecucao ? '' : this.dadosRelatorio[i + 3].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 3].dhconcluido ? '' : this.dadosRelatorio[i + 3].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 3].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 3].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 3].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 3].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 3].tempo ? '0s' : this.dadosRelatorio[i + 3].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 3].tempo ? '0s' : this.dadosRelatorio[i + 3].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
        } else if (i + 2 < this.dadosRelatorio.length) {
          htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade}</p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 1].idtarefa} - ${this.dadosRelatorio[i + 1].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 1].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 1].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 1].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 1].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 1].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 1].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 1].dhinicioexecucao ? '' : this.dadosRelatorio[i + 1].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 1].dhconcluido ? '' : this.dadosRelatorio[i + 1].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 1].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 1].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 1].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 1].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                  <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 2].idtarefa} - ${this.dadosRelatorio[i + 2].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 2].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 2].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 2].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 2].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 2].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 2].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 2].dhinicioexecucao ? '' : this.dadosRelatorio[i + 2].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 2].dhconcluido ? '' : this.dadosRelatorio[i + 2].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 2].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 2].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 2].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 2].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
        } else if (i + 1 < this.dadosRelatorio.length) {
          htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade}</p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 1].idtarefa} - ${this.dadosRelatorio[i + 1].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 1].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 1].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 1].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 1].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 1].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 1].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 1].dhinicioexecucao ? '' : this.dadosRelatorio[i + 1].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 1].dhconcluido ? '' : this.dadosRelatorio[i + 1].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 1].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 1].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 1].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 1].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
        } else {
          htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade}</p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
        }
        promessas.push(html2pdf().from(htmlContent).set(opt).outputImg());
      }

      var body1 = chartsContainer2.innerHTML;
      var body2 = chartsContainer.innerHTML;

      let htmlGraficos = `
                <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header2 {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }

                          .header2 h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader2 {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                          }

                          .subheader2 h6 {
                              margin: 0;
                          }


                          .report-container2 {
                              background-color: #fff;
                              padding: 20px 20px 12px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                          }
                          .demand-header2 {
                              border-bottom: 1px solid #333;
                              margin-bottom: 10px;
                              padding-bottom: 10px;
                          }
                          .demand-header2 h2 {
                              margin: 0;
                              font-size: 20px;
                          }

                          .demand-info2 {
                              margin: 20px 0 15px 0;
                          }
                          .demand-info2 p {
                              margin: 5px 0;
                          }

                          .demand-info2 p {
                              margin: 5px 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info2 p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container2 {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr);
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                              border: 1px solid #ddd;
                          }
                          .time-container2 p {
                              margin: 0;
                              font-size: 13px;
                          }
                          .grafico{
                              display: block !important;
                          }
                          /*.report-container-pai{*/
                          /*    display: grid;*/
                          /*    grid-template-columns: repeat(2, 1fr);*/
                          /*    gap: 10px;*/
                          /*    background-color: #f1f1f1;*/
                          /*    padding: 10px;*/
                          /*    border-radius: 5px;*/
                          /*    margin: 10px 0;*/
                          /*    border: 1px solid #ddd;*/
                          /*}*/
                      </style>
                  </head>
                  <body>
                  <div class="header2">
                      <h2>Relatório de Demandas TI - Sintético</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader2">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container2">
                      <div class="demand-header2">
                          <h2>Totais</h2>
                      </div>

                      <div class="demand-info2">
                          <div class="time-container2">
                              <p><strong>Total Demandas:</strong> ${!this.totalRelatorio.totaldemandas ? 0 : this.totalRelatorio.totaldemandas}</p>
                              <p><strong>Total Concluídas:</strong> ${!this.totalRelatorio.totalconcluidas ? 0 : this.totalRelatorio.totalconcluidas}</p>
                              <p><strong>Total Pendentes:</strong> ${!this.totalRelatorio.totalpendentes ? 0 : this.totalRelatorio.totalpendentes}</p>
                              <p><strong>Tempo Trabalhado:</strong> ${!this.totalRelatorio.totaltempoexecutando ? 0 : this.totalRelatorio.totaltempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  ${body1}
                  ${body2}
                  </body>
                  </html>
      `;
      promessas.push(html2pdf().from(htmlGraficos).set(opt).outputImg());

      // Espera todas as imagens serem processadas antes de adicionar ao PDF
      const imagens = await Promise.all(promessas);

      // Adiciona cada imagem ao PDF
      imagens.forEach((img, index) => {
        if (index > 0) doc.addPage();
        doc.addImage(img.src, 'jpeg', opt.margin[0], opt.margin[1], pageSize.width, pageSize.height);
      });

      doc.save(opt.filename);
    },
    async gerarPdfBkp(){
        var dtini = this.formataData(
            this.busca.dtinicio
        );
        var dtfim = this.formataData(
            this.busca.dtfim
        );

        const chartsContainer = document.getElementById('charts-container');
        const chartsContainer2 = document.getElementById('charts-container2');

        let agora = new Date();

        let ano = agora.getFullYear();
        let mes = ('0' + (agora.getMonth() + 1)).slice(-2); // +1 porque o mês começa do zero
        let dia = ('0' + agora.getDate()).slice(-2);
        let hora = ('0' + agora.getHours()).slice(-2);
        let minuto = ('0' + agora.getMinutes()).slice(-2);

        let nomeArquivo = `Demandas_TI_${ano}${mes}${dia}_${hora}${minuto}.pdf`;

        const opt = {
          margin:       [0, 0],
          filename:     nomeArquivo,
          image:        { type: 'jpeg', quality: 1 },
          html2canvas:  { dpi: 192, scale: 2 },
          jsPDF:        { unit: 'pt', format: 'a4', orientation: 'portrait' }
        };

        const doc = new jsPDF(opt.jsPDF);
        const pageSize = jsPDF.getPageSize(opt.jsPDF);

        var htmlContent = `
              <!DOCTYPE html>
              <html lang="pt-br">
              <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <title>Relatório de Demandas Executadas</title>
                  <style>
                      body, html {
                          margin: 0;
                          padding: 0;
                          width: 100%;
                          height: 100%;
                          font-family: Arial, sans-serif;
                          background-color: #f0f0f0;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                      }
                      .cover {
                          width: 210mm;
                          height: 297mm;
                          background-color: #023449;
                          display: flex;
                          flex-direction: column;
                          justify-content: center;
                          align-items: center;
                          text-align: center;
                          color: white;
                          padding: 20px;
                          box-sizing: border-box;
                          border: 1px solid #ccc; /* Opcional: adiciona uma borda para visualizar os limites da folha */
                      }
                      .cover h1 {
                          font-size: 2.5em;
                          margin-bottom: 0.5em;
                      }
                      .cover h2 {
                          font-size: 1.5em;
                          margin-bottom: 1em;
                      }
                      .cover p {
                          font-size: 0.9em;
                      }
                      .logo {
                          margin-bottom: 240px;
                      }
                      .logo img {
                          width: 200px;
                          height: auto;
                      }
                      .page-break {
                          page-break-before: always;
                          break-before: page;
                      }
                  </style>
              </head>
              <body>
                  <div class="cover">
                      <div class="logo">
                          <svg width="320" height="140" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                              <g filter="url(#filter0_d_1_16)">
                              <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                              </g>
                              <g filter="url(#filter1_d_1_16)">
                              <rect x="235" y="308" width="158" height="158" fill="white"/>
                              </g>
                              <g filter="url(#filter2_d_1_16)">
                              <rect x="7" y="245" width="221" height="221" fill="white"/>
                              </g>
                              <g filter="url(#filter3_d_1_16)">
                              <rect x="7" y="13" width="221" height="221" fill="white"/>
                              </g>
                              <defs>
                              <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feOffset dx="9" dy="4"/>
                              <feGaussianBlur stdDeviation="3.5"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feOffset dx="10" dy="-4"/>
                              <feGaussianBlur stdDeviation="4"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                              <feOffset dx="18" dy="12"/>
                              <feGaussianBlur stdDeviation="11"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                              <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                              <feOffset dx="18" dy="12"/>
                              <feGaussianBlur stdDeviation="11"/>
                              <feComposite in2="hardAlpha" operator="out"/>
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                              </filter>
                              </defs>
                          </svg>
                      </div>
                      <h1>Relatório de Demandas</h1>
                      <h2>Setor de Desenvolvimento TI</h2>
                      <p>Período: ${dtini} à ${dtfim}</p>
                  </div>
              </body>
              </html>

               `;
        const pageImage = await html2pdf().from(htmlContent).set(opt).outputImg();
        doc.addImage(pageImage.src, 'jpeg', opt.margin[0], opt.margin[1], pageSize.width, pageSize.height);
        doc.addPage();

        for (let i = 0; i < this.dadosRelatorio.length; i += 4) {
          if (i + 3 < this.dadosRelatorio.length) {
            htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade} </p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 1].idtarefa} - ${this.dadosRelatorio[i + 1].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 1].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 1].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 1].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 1].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 1].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 1].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 1].dhinicioexecucao ? '' : this.dadosRelatorio[i + 1].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 1].dhconcluido ? '' : this.dadosRelatorio[i + 1].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 1].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 1].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 1].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 1].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                  <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 2].idtarefa} - ${this.dadosRelatorio[i + 2].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 2].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 2].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 2].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 2].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 2].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 2].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 2].dhinicioexecucao ? '' : this.dadosRelatorio[i + 2].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 2].dhconcluido ? '' : this.dadosRelatorio[i + 2].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 2].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 2].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 2].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 2].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                  <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 3].idtarefa} - ${this.dadosRelatorio[i + 3].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 3].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 3].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 3].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 3].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 3].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 3].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 3].dhinicioexecucao ? '' : this.dadosRelatorio[i + 3].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 3].dhconcluido ? '' : this.dadosRelatorio[i + 3].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 3].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 3].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 3].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 3].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 3].tempo ? '0s' : this.dadosRelatorio[i + 3].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 3].tempo ? '0s' : this.dadosRelatorio[i + 3].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
          } else if (i + 2 < this.dadosRelatorio.length) {
            htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade}</p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 1].idtarefa} - ${this.dadosRelatorio[i + 1].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 1].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 1].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 1].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 1].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 1].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 1].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 1].dhinicioexecucao ? '' : this.dadosRelatorio[i + 1].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 1].dhconcluido ? '' : this.dadosRelatorio[i + 1].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 1].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 1].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 1].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 1].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                  <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 2].idtarefa} - ${this.dadosRelatorio[i + 2].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 2].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 2].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 2].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 2].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 2].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 2].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 2].dhinicioexecucao ? '' : this.dadosRelatorio[i + 2].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 2].dhconcluido ? '' : this.dadosRelatorio[i + 2].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 2].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 2].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 2].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 2].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 2].tempo ? '0s' : this.dadosRelatorio[i + 2].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
          } else if (i + 1 < this.dadosRelatorio.length) {
            htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade}</p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i + 1].idtarefa} - ${this.dadosRelatorio[i + 1].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i + 1].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i + 1].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i + 1].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i + 1].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i + 1].descricao}</p>

                          <div class="time-container">
                            <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i + 1].dhcadastro}</p>
                            <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i + 1].dhinicioexecucao ? '' : this.dadosRelatorio[i + 1].dhinicioexecucao}</p>
                            <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i + 1].dhconcluido ? '' : this.dadosRelatorio[i + 1].dhconcluido}</p>
                            <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i + 1].prioridade}</p>
                            <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i + 1].usuariosolicitacao}</p>
                            <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i + 1].usuariodesenvolvedor ? '' : this.dadosRelatorio[i + 1].usuariodesenvolvedor}</p>
                            <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoaguardando}</p>
                            <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i + 1].tempo ? '0s' : this.dadosRelatorio[i + 1].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
          } else {
            htmlContent = `
                    <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }

                          .header h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                          }

                          .subheader h6 {
                              margin: 0;
                          }

                          .report-container {
                              background-color: #fff;
                              padding: 14px 20px 10px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                              border-bottom: 1px solid rgba(0,0,0,0.25);
                          }
                          .demand-header {
                              border-bottom: 1px solid #333;
                              padding-bottom: 10px;
                              margin-bottom: 10px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }
                          .demand-header h2 {
                              margin: 0;
                              font-size: 16px !important;
                              text-transform: uppercase;
                          }

                          .demand-info p {
                              margin: 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr) !important;
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px 10px 15px 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                          }
                          .time-container p {
                          height: 31px;
                              margin: 0;
                              font-size: 11px !important;
                          }
                          .page-break {
                              page-break-before: always;
                              break-before: page;
                          }
                          .chip {
                            display: inline-flex;
                            align-items: center;
                            padding: 0 12px;
                            font-size: 12px !important;
                            height: 22px;
                            background-color: #e0e0e0;
                            border-radius: 10px;
                            color: #424242;
                            cursor: default;
                            user-select: none;
                            white-space: nowrap;
                        }
                        .chip-orange-dark {
                            background-color: #E65100;
                            color:#FFFFFF;
                        }

                        .chip-orange {
                            background-color: #FF6F00;
                            color:#FFFFFF;
                        }

                        .chip-yellow {
                            background-color: #F57F17;
                            color:#FFFFFF;
                        }

                        .chip-primary {
                            background-color: #023449;
                            color:#FFFFFF;
                        }
                      </style>
                  </head>
                  <body>
                  <div class="header">
                      <h2>Relatório de Demandas TI</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container">
                      <div class="demand-header">
                        <h2>#${this.dadosRelatorio[i].idtarefa} - ${this.dadosRelatorio[i].tarefa}</h2>
                          <div class="chip ${this.dadosRelatorio[i].idstatus == 4 ? 'chip-primary' : this.dadosRelatorio[i].idstatus == 3 ? 'chip-orange-dark' : this.dadosRelatorio[i].idstatus == 2 ? 'chip-orange' : 'chip-yellow'}">
                            ${this.dadosRelatorio[i].status}
                          </div>
                        </div>

                      <div class="demand-info">
                          <p>${this.dadosRelatorio[i].descricao}</p>

                          <div class="time-container">
                              <p><strong>Data/Hora Cadastro:</strong> ${this.dadosRelatorio[i].dhcadastro}</p>
                              <p><strong>Data/Hora Início:</strong> ${!this.dadosRelatorio[i].dhinicioexecucao ? '' : this.dadosRelatorio[i].dhinicioexecucao}</p>
                              <p><strong>Data/Hora Finalização:</strong> ${!this.dadosRelatorio[i].dhconcluido ? '' : this.dadosRelatorio[i].dhconcluido}</p>
                              <p><strong>Prioridade:</strong> ${this.dadosRelatorio[i].prioridade}</p>
                              <p><strong>Solicitante:</strong> ${this.dadosRelatorio[i].usuariosolicitacao}</p>
                              <p><strong>Desenvolvedor:</strong> ${!this.dadosRelatorio[i].usuariodesenvolvedor ? '' : this.dadosRelatorio[i].usuariodesenvolvedor}</p>
                              <p><strong>Tempo Pausada/Aguardando</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoaguardando}</p>
                              <p><strong>Tempo Executando:</strong> ${!this.dadosRelatorio[i].tempo ? '0s' : this.dadosRelatorio[i].tempo[0].tempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  <div class="page-break"></div>
                  </body>
                  </html>`;
          }
          const pageImage = await html2pdf().from(htmlContent).set(opt).outputImg();
          doc.addImage(pageImage.src, 'jpeg', opt.margin[0], opt.margin[1], pageSize.width, pageSize.height);
          doc.addPage();
        }

        var body1 = chartsContainer2.innerHTML;
        var body2 = chartsContainer.innerHTML;

        htmlContent = `
                <!DOCTYPE html>
                  <html lang="pt-BR">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Relatório de Demandas do Setor de Desenvolvimento</title>
                      <style>
                          body {
                              font-family: Arial, sans-serif;
                              margin: 20px;
                              padding: 0;
                              background-color: #f4f4f4;
                          }
                          .header2 {
                              background-color: #023449;
                              padding: 15px 20px 10px 20px;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                          }

                          .header2 h2 {
                              margin: 0;
                              color: #fff;
                          }

                          .subheader2 {
                              background-color: #f1f1f1;
                              padding: 10px 20px 10px 20px;
                              text-align: center;
                          }

                          .subheader2 h6 {
                              margin: 0;
                          }


                          .report-container2 {
                              background-color: #fff;
                              padding: 20px 20px 12px 20px;
                              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                          }
                          .demand-header2 {
                              border-bottom: 1px solid #333;
                              margin-bottom: 10px;
                              padding-bottom: 10px;
                          }
                          .demand-header2 h2 {
                              margin: 0;
                              font-size: 20px;
                          }

                          .demand-info2 {
                              margin: 20px 0 15px 0;
                          }
                          .demand-info2 p {
                              margin: 5px 0;
                          }

                          .demand-info2 p {
                              margin: 5px 0;
                              padding: 3px;
                              border-radius: 5px;
                              font-size: 14px;
                          }
                          .demand-info2 p strong {
                              display: block;
                              font-weight: bold;
                              margin-bottom: 5px;
                              color: #333;
                          }
                          .time-container2 {
                              display: grid;
                              grid-template-columns: repeat(4, 1fr);
                              gap: 10px;
                              background-color: #f1f1f1;
                              padding: 10px;
                              border-radius: 5px;
                              margin: 10px 0;
                              border: 1px solid #ddd;
                          }
                          .time-container2 p {
                              margin: 0;
                              font-size: 13px;
                          }
                          .grafico{
                              display: block !important;
                          }
                          /*.report-container-pai{*/
                          /*    display: grid;*/
                          /*    grid-template-columns: repeat(2, 1fr);*/
                          /*    gap: 10px;*/
                          /*    background-color: #f1f1f1;*/
                          /*    padding: 10px;*/
                          /*    border-radius: 5px;*/
                          /*    margin: 10px 0;*/
                          /*    border: 1px solid #ddd;*/
                          /*}*/
                      </style>
                  </head>
                  <body>
                  <div class="header2">
                      <h2>Relatório de Demandas TI - Sintético</h2>
                      <svg width="140" height="40" viewBox="0 0 1835 551" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="235" y="138" width="158" height="158" fill="#FFC000"/>
                        <g filter="url(#filter0_d_1_16)">
                        <path d="M502.245 471.14C546.405 471.14 580.56 453.89 605.4 432.845V327.965H500.52V373.85H553.995V408.35C540.54 418.01 523.29 422.84 503.97 422.84C461.19 422.84 430.83 390.41 430.83 346.25V345.56C430.83 304.505 461.535 270.35 500.175 270.35C528.12 270.35 544.68 279.32 563.31 294.845L596.775 254.48C571.59 233.09 545.37 221.36 501.9 221.36C428.76 221.36 375.285 277.595 375.285 346.25V346.94C375.285 418.355 427.035 471.14 502.245 471.14ZM656.522 467H840.407V419.735H709.307V369.02H823.157V321.755H709.307V272.765H838.682V225.5H656.522V467ZM973.55 470.45C1025.65 470.45 1062.22 443.54 1062.22 395.585V394.895C1062.22 352.805 1034.62 335.21 985.625 322.445C943.88 311.75 933.53 306.575 933.53 290.705V290.015C933.53 278.285 944.225 268.97 964.58 268.97C984.935 268.97 1005.98 277.94 1027.37 292.775L1054.97 252.755C1030.48 233.09 1000.46 222.05 965.27 222.05C915.935 222.05 880.745 251.03 880.745 294.845V295.535C880.745 343.49 912.14 356.945 960.785 369.365C1001.15 379.715 1009.43 386.615 1009.43 400.07V400.76C1009.43 414.905 996.32 423.53 974.585 423.53C946.985 423.53 924.215 412.145 902.48 394.205L871.085 431.81C900.065 457.685 936.98 470.45 973.55 470.45ZM1159.51 467H1212.64V274.49H1286.12V225.5H1086.02V274.49H1159.51V467ZM1433.84 471.14C1508.36 471.14 1562.52 414.905 1562.52 346.25V345.56C1562.52 276.905 1509.05 221.36 1434.53 221.36C1360.01 221.36 1305.84 277.595 1305.84 346.25V346.94C1305.84 415.595 1359.32 471.14 1433.84 471.14ZM1434.53 422.15C1391.75 422.15 1361.39 387.65 1361.39 346.25V345.56C1361.39 304.16 1391.06 270.35 1433.84 270.35C1476.62 270.35 1506.98 304.85 1506.98 346.25V346.94C1506.98 388.34 1477.31 422.15 1434.53 422.15ZM1609.65 467H1662.78V389.72H1703.84H1704.53L1756.28 467H1818.38L1759.38 380.75C1790.09 369.365 1811.13 344.87 1811.13 305.885V305.195C1811.13 282.425 1803.89 263.45 1790.43 249.995C1774.56 234.125 1750.76 225.5 1720.05 225.5H1609.65V467ZM1662.78 342.8V273.455H1715.57C1741.44 273.455 1757.31 285.185 1757.31 307.955V308.645C1757.31 329 1742.48 342.8 1716.6 342.8H1662.78Z" fill="white"/>
                        </g>
                        <g filter="url(#filter1_d_1_16)">
                        <rect x="235" y="308" width="158" height="158" fill="white"/>
                        </g>
                        <g filter="url(#filter2_d_1_16)">
                        <rect x="7" y="245" width="221" height="221" fill="white"/>
                        </g>
                        <g filter="url(#filter3_d_1_16)">
                        <rect x="7" y="13" width="221" height="221" fill="white"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1_16" x="375.285" y="218.36" width="1459.09" height="263.78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="9" dy="4"/>
                        <feGaussianBlur stdDeviation="3.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter1_d_1_16" x="235" y="296" width="176" height="174" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="10" dy="-4"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter2_d_1_16" x="0" y="232" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        <filter id="filter3_d_1_16" x="0" y="0" width="271" height="271" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_16"/>
                        <feOffset dx="18" dy="12"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_16"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_16" result="shape"/>
                        </filter>
                        </defs>
                      </svg>
                  </div>

                  <div class="subheader2">
                      <h6>Período: ${dtini} à ${dtfim}</h6>
                  </div>

                  <div class="report-container2">
                      <div class="demand-header2">
                          <h2>Totais</h2>
                      </div>

                      <div class="demand-info2">
                          <div class="time-container2">
                              <p><strong>Total Demandas:</strong> ${!this.totalRelatorio.totaldemandas ? 0 : this.totalRelatorio.totaldemandas}</p>
                              <p><strong>Total Concluídas:</strong> ${!this.totalRelatorio.totalconcluidas ? 0 : this.totalRelatorio.totalconcluidas}</p>
                              <p><strong>Total Pendentes:</strong> ${!this.totalRelatorio.totalpendentes ? 0 : this.totalRelatorio.totalpendentes}</p>
                              <p><strong>Qtde de Dias Filtrados:</strong> ${!this.totalRelatorio.totaltempoexecutando ? 0 : this.totalRelatorio.totaltempoexecutando} </p>
                          </div>
                      </div>
                  </div>
                  ${body1}
                  ${body2}
                  </body>
                  </html>
      `;

        const pageImage2 = await html2pdf().from(htmlContent).set(opt).outputImg();
        doc.addImage(pageImage2.src, 'jpeg', opt.margin[0], opt.margin[1], pageSize.width, pageSize.height);

        doc.save(opt.filename);
    },
    async gerarPdf2() {
      const chartsContainer = document.getElementById('charts-container');
      const chartsContainer2 = document.getElementById('charts-container2');

      let agora = new Date();

      let ano = agora.getFullYear();
      let mes = ('0' + (agora.getMonth() + 1)).slice(-2); // +1 porque o mês começa do zero
      let dia = ('0' + agora.getDate()).slice(-2);
      let hora = ('0' + agora.getHours()).slice(-2);
      let minuto = ('0' + agora.getMinutes()).slice(-2);

      let nomeArquivo = `Demandas_TI_${ano}${mes}${dia}_${hora}${minuto}.pdf`;

      const opt = {
        margin: [0, 0],
        filename: nomeArquivo,
        image: {type: 'jpeg', quality: 0.75},
        html2canvas: {dpi: 192, scale: 2},
        jsPDF: {unit: 'pt', format: 'a4', orientation: 'portrait'}
      };

      const doc = new jsPDF(opt.jsPDF);
      const pageSize = jsPDF.getPageSize(opt.jsPDF);

      var htmlContent = '' //html capa do relatorio
      const pageImage = await html2pdf().from(htmlContent).set(opt).outputImg();
      doc.addImage(pageImage.src, 'jpeg', opt.margin[0], opt.margin[1], pageSize.width, pageSize.height);
      doc.addPage();

      for (let i = 0; i < this.dadosRelatorio.length; i += 4) {
        if (i + 3 < this.dadosRelatorio.length) {
          htmlContent = '' //html com 4 registros na pagina
        } else if (i + 2 < this.dadosRelatorio.length) {
          htmlContent = '' //html com 3 registros na pagina
        } else if (i + 1 < this.dadosRelatorio.length) {
          htmlContent = '' //html com 2 registros na pagina
        } else {
          htmlContent = '' //html com 1 registro na pagina
        }
        const pageImage = await html2pdf().from(htmlContent).set(opt).outputImg();
        doc.addImage(pageImage.src, 'jpeg', opt.margin[0], opt.margin[1], pageSize.width, pageSize.height);
        doc.addPage();
      }

      var body1 = chartsContainer2.innerHTML;
      var body2 = chartsContainer.innerHTML;

      htmlContent = `${body1}${body2}` //html com graticos de totais

      const pageImage2 = await html2pdf().from(htmlContent).set(opt).outputImg();
      doc.addImage(pageImage2.src, 'jpeg', opt.margin[0], opt.margin[1], pageSize.width, pageSize.height);

      doc.save(opt.filename);
    },
    verificaFiltros() {
      const json = localStorage.getItem("filtros_kanban");
      const filtro = JSON.parse(json);
      if (filtro) {
        this.busca = filtro;
      }
    },
    getTarefas(pg) {
      this.pgSelecionada = pg;
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}projeto/tarefa/listar`, {
            limit: 1000,
            offset: this.pgLimitInt * pg,
            idprojeto: 1,
            dtini: this.busca.dtinicio || null,
            dtfim: this.busca.dtfim || null,
            idstatus: this.busca.idstatus,
            filtroDemandasUsuario: this.busca.filtroDemandasUsuario,
          })
          .then((res) => {
            localStorage.setItem(
                "filtros_kanban",
                JSON.stringify(this.busca)
            );

            if (res.data.lista != null) {
              this.carregando = false;
              this.totalRelatorio = res.data.totais;
              this.dadosTarefa = res.data.lista;
              this.lista1 = res.data.lista.filter((v) => v.idstatus == 1);
              this.lista2 = res.data.lista.filter((v) => v.idstatus == 2);
              this.lista3 = res.data.lista.filter((v) => v.idstatus == 3);
              this.lista4 = res.data.lista.filter((v) => v.idstatus == 4);
            } else {
              this.carregando = false;
              this.totalTarefa = {};
              this.dadosTarefa = [];
            }
          })
          .catch(() => {
            this.carregando = false;
          });
    },
    adicionarTarefas() {
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}projeto/tarefa/abrir`, {
            idprojeto: 1,
            tarefa: this.tarefaTemp.tarefa,
            descricao: this.tarefaTemp.descricao,
            idusuariosolicitacao: this.tarefaTemp.idusuariosolicitacao,
            tempomedio: this.tarefaTemp.tempomedio,
            idprioridade: this.tarefaTemp.idprioridade,
            idsetor: this.tarefaTemp.idsetor,
            idplanejamento: this.tarefaTemp.idplanejamento
          })
          .then((res) => {
            if (res.data) {
              this.snackbar.text = "Demanda adicionada com sucesso";
              this.snackbar.status = true;
              this.snackbar.color = "green darken-3";
              this.getTarefas(0);
              this.dialogAdicionar = false;
              this.tarefaTemp = {};
              this.carregando = false;
            } else {
              this.snackbar.text =
                  "Não foi possível adicionar demanda!";
              this.snackbar.status = true;
              this.snackbar.color = "red darken-3";
              this.carregando = false;
            }
          })
          .catch(() => {
            this.carregando = false;
          });
    },
    alterarTarefas() {
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}projeto/tarefa/atualizar`, {
            idprojeto: 1,
            idtarefa: this.dadosAlteracao.idtarefa,
            idprioridade: this.dadosAlteracao.idprioridade,
            tarefa: this.dadosAlteracao.tarefa,
            descricao: this.dadosAlteracao.descricao,
            idusuariosolicitacao: this.dadosAlteracao.idusuariosolicitacao,
            idstatus: this.dadosAlteracao.idstatus,
            idsetor: this.dadosAlteracao.idsetor,
            idplanejamento: this.dadosAlteracao.idplanejamento
          })
          .then((res) => {
            if (res.data) {
              this.snackbar.text = "Demanda adicionada com sucesso";
              this.snackbar.status = true;
              this.snackbar.color = "green darken-3";
              this.getTarefas(0);
              this.dialogAlterar = false;
              this.dadosAlteracao = {
                descricao: '',
                tarefa: '',
              };
              this.carregando = false;
            } else {
              this.snackbar.text =
                  "Não foi possível adicionar demanda!";
              this.snackbar.status = true;
              this.snackbar.color = "red darken-3";
              this.carregando = false;
            }
          })
          .catch(() => {
            this.carregando = false;
          });
    },
    listarUsuarios() {
      this.usuarios.lista = [];
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}usuario/listar`, {
            busca: this.tarefaTemp.idusuariosolicitacao,
            notidgrupo: 3,
            status: true,
            limit: 99999,
            offset: 0,
          })
          .then((res) => {
            if (res.data.lista != null) {
              this.usuarios = res.data;
            }
            this.carregando = false;
          });
    },
		corItem(id) {
			switch (id) {
				case 1:
					return "yellow darken-4";
				case 2:
					return "amber darken-4";
				case 3:
					return "orange darken-4";
				default:
					return "primary";
			}
		},
		listarStatus() {
			return axios
				.post(`${this.backendUrl}projeto/tarefa/status`)
				.then((res) => {
					this.status = res.data;
				});
		},
    listarPrioridades() {
			return axios
				.post(`${this.backendUrl}projeto/tarefa/prioridade`)
				.then((res) => {
          this.prioridade = res.data.lista.map((v) => {
            return {
              idprioridade: v.idprioridade,
              prioridade: `${v.idprioridade} - ${v.prioridade}`,
            };
          });
				});
		},
    listarSetor() {
      return axios
          .post(`${this.backendUrl}projeto/tarefa/setor`)
          .then((res) => {
            this.setor = res.data.lista;
          });
    },
    listarPlanejamento() {
			return axios
				.post(`${this.backendUrl}projeto/tarefa/planejamento`)
				.then((res) => {
          this.planejamento = res.data.lista.map((v) => {
            return {
              idplanejamento: v.idplanejamento,
              planejamento: `${v.planejamento}`,
            };
          });
				});
		},
		exibirDetalhes(tarefa, tipo) {
      if (tipo == 'D') {
        this.tarefaTemp = {};
        this.tarefaTemp = tarefa;
        this.tab=1;
        this.dialogDetalhe = true;
        this.listarRegistros();
      } else {
        this.dadosAlteracao= {
          descricao: '',
          tarefa: '',
        };
        this.dadosAlteracao = JSON.parse(JSON.stringify(tarefa));
        this.dialogAlterar = true;
      }
		},
		confirmaDelecao(tarefa) {
			this.tarefaTemp = {};
			this.tarefaTemp = tarefa;
			this.dialogDelete = true;
		},
		atualizarTarefa(tarefa, idstatus) {
      var newStatus
      if (idstatus) {
        newStatus = idstatus
      } else {
        newStatus = tarefa.idstatus
      }
			switch (newStatus) {
				case 1:
					tarefa.status = "A executar";
					break;
				case 2:
					tarefa.status = "Executando";
					break;
				case 3:
					tarefa.status = "Aguardando";
					break;
				case 4:
					tarefa.status = "Concluída";
					break;
			}
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}projeto/tarefa/atualizar`, {
					idtarefa: tarefa.idtarefa,
					concluida: tarefa.concluida,
					validada: tarefa.validada,
					idstatus: newStatus,
					status: tarefa.status,
          idsetor: tarefa.idsetor,
				})
				.then((res) => {
					if (res.data) {
						this.snackbar.text = "Demanda atualizada com sucesso";
						this.snackbar.status = true;
						this.snackbar.color = "green darken-3";
            this.getTarefas(0);
					} else {
						this.snackbar.text = "Erro ao atualizar demanda";
						this.snackbar.status = true;
						this.snackbar.color = "red darken-3";
					}
					this.carregando = false;
				})
				.catch(() => {
          this.getTarefas(0);
					this.snackbar.text = "Não foi possível excluir demanda";
					this.snackbar.status = true;
					this.snackbar.color = "red darken-3";
					this.carregando = false;
				});
		},
		deletarTarefa(tarefa) {
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}projeto/tarefa/deletar`, {
					idtarefa: parseInt(tarefa.idtarefa),
				})
				.then((res) => {
					if (res.data) {
						this.snackbar.text = "Demanda excluída com sucesso";
						this.snackbar.status = true;
						this.getTarefas(0);
					} else {
						this.snackbar.text = "Erro ao excluir demanda";
						this.snackbar.status = true;
						this.snackbar.color = "red darken-3";
					}
					this.carregando = false;
				})
				.catch(() => {
					this.snackbar.text = "Não foi possível excluir demanda";
					this.snackbar.status = true;
					this.snackbar.color = "red darken-3";
					this.carregando = false;
				});
		},
		arquivoNovo(tarefa) {
      this.carregando = true;
			if (this.arquivos.length == 0) {
        this.carregando = false;
				this.snackbar.text = "Nenhum arquivo selecionado";
				this.snackbar.status = true;
				this.snackbar.color = "red darken-3";
				return;
			}
			return axios
				.post(`${this.backendUrl}projeto/tarefa/arquivo/novo`, {
					idtarefa: parseInt(tarefa.idtarefa),
					arquivo: this.arquivos || null,
				})
				.then((res) => {
					if (res.data) {
						this.getTarefas(0);
						this.snackbar.text = "Arquivo adicionado com sucesso!";
						this.snackbar.status = true;
						this.snackbar.color = "green darken-3";
            this.resetKey++;
						setTimeout(() => {
							this.tarefaTemp = this.dadosTarefa.filter((v) => v.idtarefa == tarefa.idtarefa)[0];
              this.carregando = false;
            }, 1000);
					} else {
						this.snackbar.text =
							"Não foi possível adicionar o arquivo.";
						this.snackbar.status = true;
						this.snackbar.color = "red darken-3";
            this.carregando = false;
					}
				})
				.catch(() => {
					this.snackbar.text =
						"Não foi possível adicionar o arquivo selecionado";
					this.snackbar.status = true;
					this.snackbar.color = "red darken-3";
          this.carregando = false;
				});
		},
		adicionarArquivo(arquivos) {
			this.carregando = true;
			this.arquivos = [];
			let a = [];
			for (let i = 0; i < arquivos.length; i++) {
				let reader = new FileReader();
				reader.readAsDataURL(arquivos[i]);
				reader.onload = function () {
					a[i] = {
						arquivo: reader.result.split("base64,")[1],
						arquivoname: arquivos[i].name,
					};
				};
			}
			this.arquivos = a;
			this.carregando = false;
		},
		arquivoDownload(idarquivo) {
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}projeto/tarefa/arquivo/download`, {
					idarquivo,
				})
				.then((res) => {
					this.downloadBase64(res.data);
					this.carregando = false;
				})
				.catch(() => {
					this.carregando = false;
				});
		},
		adicionarRegistro() {
			if (this.registro == "") {
				return;
			}
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}projeto/tarefa/registro/criar`, {
					idtarefa: parseInt(this.tarefaTemp.idtarefa),
					registro: this.registro,
				})
				.then((res) => {
					if (res.data) {
						this.snackbar.text = "Registro adicionado com sucesso";
						this.snackbar.status = true;
						this.registro = "";
					} else {
						this.snackbar.text =
							"Não foi possível adicionar o registro!";
						this.snackbar.status = true;
						this.snackbar.color = "red darken-3";
					}
					this.carregando = false;
					this.listarRegistros();
				})
				.catch(() => {
					this.snackbar.text =
						"Não foi possível adicionar o registro!";
					this.snackbar.status = true;
					this.snackbar.color = "red darken-3";
					this.carregando = false;
				});
		},
		listarRegistros() {
      this.registros = [];
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}projeto/tarefa/registro/listar`, {
					idtarefa: parseInt(this.tarefaTemp.idtarefa),
				})
				.then((res) => {
					this.registros = res.data;
					this.carregando = false;
				})
				.catch(() => {
					this.carregando = false;
				});
		},
    rowClass(index, item) {
      return {
        'highlight-row': item.age > 35,
        'odd-row': index % 2 !== 0,
        'even-row': index % 2 === 0,
      };
    },
		async init() {
      await this.verificaFiltros();
      await this.listarPrioridades();
      await this.listarSetor();
      await this.listarPlanejamento();
      await this.getTarefas(0);
			// await this.verificaFiltros();
			// await this.getTarefas(0);
			await this.listarStatus();
      await this.listarUsuarios();

      // await this.listarUsuariosDevs();
		},
	},
	created() {
		this.init();
	},
};
</script>

<style scoped>
.custom-card-text {
  max-height: calc(60vh - 300px) !important; /* Ajuste o valor de 100px conforme necessário */
  overflow-y: auto !important;
}

.container-scroll {
	min-height: 140px;
	max-height: 360px;
	overflow: auto;
	display: flex;
	flex-direction: column-reverse;
}
/* Estilo para todas as linhas, incluindo cabeçalho */
.styled-row {
  background-color: #b9b9b9;
}

/* Estilo para linhas pares
.even-row {
  background-color: #86fc79 !important;
}

.even-row2 {
  background-color: #86fc79 !important;
}*/

/* Estilo para linhas ímpares */
.odd-row {
  background-color: #e1e1e1;
}

/* Estilo para linhas que atendem a uma condição específica */
.highlight-row {
  background-color: #ffeb3b;
}

.custom-table {
  border-collapse: collapse; /* Garante que as bordas sejam colapsadas corretamente */
}

.custom-table th,
.custom-table td {
  border: 1px solid rgba(157, 157, 157, 0.27) !important; /* Força a aplicação da borda */
}

.ghost {
  opacity: 0.5;
  background: #023449;
}

.v-application ul {
  padding: 0px;
}

.list-group {
  min-height: 20px;
  padding-left: 10px;
  padding-right: 10px;
}

.list-card-itens {
  margin: 0;
  padding: 0;
  list-style-type: none;
  cursor: pointer;
}

.quadro-demanda {
  border: 2px solid #023449;
}

.quadro-demanda-text {
  max-height: calc(100vh - 365px) !important;
  overflow-y: auto !important;
}

/* Estilizando a barra de rolagem para navegadores WebKit */
.quadro-demanda-text::-webkit-scrollbar {
  width: 8px; /* Largura da barra de rolagem */
}

.quadro-demanda-text::-webkit-scrollbar-track {
  background: #f1f1f1; /* Cor de fundo da trilha */
}

.quadro-demanda-text::-webkit-scrollbar-thumb {
  background-color: #023449; /* Cor da barra de rolagem */
  border-radius: 10px; /* Bordas arredondadas */
  border: 2px solid #f1f1f1; /* Espaço ao redor da barra de rolagem */
}

/* Estilizando a barra de rolagem para Firefox */
.quadro-demanda-text {
  scrollbar-width: thin; /* Largura da barra de rolagem */
  scrollbar-color: #023449 #f1f1f1; /* Cor da barra de rolagem e da trilha */
}

.hover-div {
  position: relative;
  transition: background-color 0.3s ease;
}

.hidden-button {
  display: none;
  cursor: pointer;
  position: absolute;
  top: 13px;
  right: 13px;
  border-radius: 12px !important;
}

.hidden-button i {
  font-size: 16px;
}

.hover-div:hover .hidden-button {
  display: flex;
}


.hidden-prioridade {
  display: flex;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 18px;
  /* box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2); /* Propriedade para adicionar sombra */
}

.hover-div:hover .hidden-prioridade {
  display: none;
}

.time-container3 {
  margin: 10px 21px 0 21px;
  background-color: #f1f1f1;
  padding: 10px 10px 0px 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  width: 199mm !important;
}

.demand-header2 {
  margin: 10px 21px 18px 21px;
  border-bottom: 1px solid #333;
  padding-bottom: 10px;
  width: 199mm !important;
}

.demand-header2 h2 {
  margin: 0;
  font-size: 20px;
}

.icon-slide {
  animation: slideDownUp 2s ease-in-out infinite;
}

@keyframes slideDownUp {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  60% {
    transform: translateY(10px);
    opacity: 0;
  }
  61% {
    transform: translateY(-10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

</style>